export default __webpack_public_path__ + "static/media/dec6.1c12e2d3.png";